function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	new Swiper('.swiper-news', {
		slidesPerView: 1,
		spaceBetween: 20,
		autoHeight: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			992: {
				slidesPerView: 3,
			},
			576: {
				slidesPerView: 2,
			},
		}
	});

	const filterButtons = document.querySelectorAll('.calendar-list-nav-btn');
	const events = document.querySelectorAll('.calendar-list-event');

	filterButtons.forEach(button => {
		button.addEventListener('click', function () {
			filterButtons.forEach(btn => btn.classList.remove('active'));
			this.classList.add('active');

			const selectedId = this.getAttribute('data-event-type-id');

			events.forEach(event => {
				const eventTypes = event.getAttribute('data-event-type').split(',').map(type => type.trim());

				if (selectedId === 'all' || eventTypes.includes(selectedId)) {
					event.style.display = '';
				} else {
					event.style.display = 'none';
				}
			});
		});
	});
}
